var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory, LogoImage, SvgIcon, attachKey2click, LoadingIndicatorComponent } from "survey-react-ui";
import { LogoImageViewModel } from "survey-creator-core";
import { CreatorModelElement } from "./ModelElement";
var LogoImageComponent = /** @class */ (function (_super) {
    __extends(LogoImageComponent, _super);
    function LogoImageComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.rootRef = React.createRef();
        return _this;
    }
    LogoImageComponent.prototype.createModel = function (props) {
        var prevRoot = null;
        if (!!this.model) {
            prevRoot = this.model.root;
        }
        this.model = new LogoImageViewModel(props.data, prevRoot);
    };
    LogoImageComponent.prototype.getUpdatedModelProps = function () {
        return ["data"];
    };
    LogoImageComponent.prototype.getStateElement = function () {
        return this.model;
    };
    LogoImageComponent.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.model.root = this.rootRef.current;
    };
    LogoImageComponent.prototype.renderChooseButton = function () {
        var _this = this;
        return attachKey2click(React.createElement("span", { className: "svc-context-button", onClick: function () { return _this.model.chooseFile(_this.model); } },
            React.createElement(SvgIcon, { size: "auto", iconName: "icon-choosefile" })));
    };
    LogoImageComponent.prototype.renderClearButton = function () {
        var _this = this;
        return attachKey2click(React.createElement("span", { className: "svc-context-button svc-context-button--danger", onClick: function () { return _this.model.remove(_this.model); } },
            React.createElement(SvgIcon, { size: "auto", iconName: "icon-clear" })));
    };
    LogoImageComponent.prototype.renderButtons = function () {
        return (React.createElement("div", { className: "svc-context-container svc-logo-image-controls" },
            this.renderChooseButton(),
            this.renderClearButton()));
    };
    LogoImageComponent.prototype.renderImage = function () {
        return React.createElement("div", { className: this.model.containerCss },
            this.renderButtons(),
            React.createElement(LogoImage, { data: this.props.data.survey }));
    };
    LogoImageComponent.prototype.renderPlaceHolder = function () {
        var _this = this;
        return this.model.allowEdit && !this.model.isUploading ? attachKey2click(React.createElement("div", { className: "svc-logo-image-placeholder", onClick: function () { return _this.model.chooseFile(_this.model); } },
            React.createElement("svg", null,
                React.createElement("use", { xlinkHref: "#icon-image-48x48" })))) : null;
    };
    LogoImageComponent.prototype.renderInput = function () {
        return React.createElement("input", { "aria-hidden": "true", type: "file", tabIndex: -1, accept: this.model.acceptedTypes, className: "svc-choose-file-input" });
    };
    LogoImageComponent.prototype.renderLoadingIndicator = function () {
        return React.createElement("div", { className: "svc-logo-image__loading" },
            React.createElement(LoadingIndicatorComponent, null));
    };
    LogoImageComponent.prototype.render = function () {
        var content = null;
        if (this.model.survey.locLogo.renderedHtml && !this.model.isUploading) {
            content = this.renderImage();
        }
        else if (this.model.isUploading) {
            content = this.renderLoadingIndicator();
        }
        else {
            content = this.renderPlaceHolder();
        }
        return (React.createElement("div", { ref: this.rootRef, className: "svc-logo-image" },
            this.renderInput(),
            content));
    };
    return LogoImageComponent;
}(CreatorModelElement));
export { LogoImageComponent };
ReactElementFactory.Instance.registerElement("svc-logo-image", function (props) {
    return React.createElement(LogoImageComponent, props);
});
